import {
  ORGANIZATION,
  OFFICIAL_INSTAGRAM_URL,
  getOrganizationSameAs,
  SITE_DEFAULT_ORIGIN,
} from '../config/siteOrganization';

function toAbsoluteUrl(path: string, origin: string): string {
  try {
    return new URL(path, origin).href;
  } catch {
    return path;
  }
}

/** 実行時 origin が無いとき（ビルド検証用） */
export function defaultOriginForJsonLd(): string {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return import.meta.env.VITE_PUBLIC_SITE_URL || SITE_DEFAULT_ORIGIN;
}

/**
 * Organization JSON-LD（指定フィールド＋ legalName / メール contactPoint）
 * 電話番号はサイト上に記載が無いため email の ContactPoint とする。
 * sameAs は公式 Instagram（{@link OFFICIAL_INSTAGRAM_URL}）のみ。フッターと常に同一。
 */
export function buildOrganizationJsonLd(origin: string): Record<string, unknown> {
  const baseOrigin = origin.replace(/\/$/, '');
  const orgUrl = `${baseOrigin}/`;
  const logoUrl = toAbsoluteUrl(ORGANIZATION.logoPath, origin);

  const base: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: ORGANIZATION.name,
    legalName: ORGANIZATION.legalName,
    url: orgUrl,
    logo: logoUrl,
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: ORGANIZATION.contactType,
      email: ORGANIZATION.contactEmail,
      areaServed: 'JP',
    },
  };

  const sameAs = getOrganizationSameAs();
  if (sameAs.length > 0) {
    base.sameAs = [...sameAs];
  }

  return base;
}
